<div class="fullcontainer pr-3">
  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Warehousing Reports</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/warehousing/dashboard'><i class="fas fa-tachometer-alt"></i> Dashboard</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/stock-levels'><i class="fas fa-layer-group"></i> Stock Levels</button>&nbsp;
    </div>
  </div>

  <div class="row content-block p-3">
    @for (report of this.reports; track report.link) {
      <div class="col-4 mb-3">
        <button class='btn btn-block btn-primary' [routerLink]='report.link'>
          <i [class]='report.icon'></i> {{ report.name }}
        </button>
        <small class='text-muted d-block mt-1'>{{ report.description }}</small>
      </div>
    }
  </div>
</div>
